import React from 'react';

import styled from 'styled-components';
import { Radio } from 'antd';

const StyledRadioGroup = styled(Radio.Group)``;

const StyledRadio = styled(Radio)``;

const RadioGroup = ({ options = [], name, value, onChange }) => (
  <StyledRadioGroup onChange={onChange} value={value} name={name}>
    {options.map((option, i) => (
      <StyledRadio key={`${name}-radio-${i}`} value={option['value']}>
        {option['label']}
      </StyledRadio>
    ))}
  </StyledRadioGroup>
);

export default RadioGroup;
